import { useContext } from "react"
import { VideoContext } from "../components/VideoProvider"

export default function useVideo() {
    const context = useContext(VideoContext)

    if (!context) {
        throw new Error("Debes utilizar el hook useVideo dentro del VideoProvider")
    }

    return context
}